import { ComponentType } from "react";
import { PositionNameFragment } from "gql/graphql";
import { LocalizedName } from "@/shared/data-display/localized-value";
import { Hidable, Value } from "@/shared/value";

/**
 * Название должности.
 *
 * Должность приезжает вложенной в защищённые сущности — человека, назначение, вакансию,
 * — поэтому разворачивать `position.name.value` на месте показа нельзя: каждое такое
 * место заново решало, что делать со скрытым и с пустым значением, и решало по-разному.
 */
export function PositionName({
  data,
  whenEmpty,
}: {
  data?: Hidable<PositionNameFragment>;
  whenEmpty?: ComponentType;
}) {
  return (
    <Value data={data} whenEmpty={whenEmpty}>
      {(position) => (
        <LocalizedName data={position.name} whenEmpty={whenEmpty} />
      )}
    </Value>
  );
}
